import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CreateProductActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class CreateProductEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getCreateProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateProductActions.getCreateProduct),
      switchMap((action) =>
        this.onboardingProductsService.getCreateProduct(action.request).pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) => CreateProductActions.getCreateProductSucess({ response: res })),
          catchError((error) =>
            of(
              CreateProductActions.getCreateProductError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    res = res['response'];
    const response = res;
    if (_.get(res, 'status.code', '') === 200 || _.get(res, 'status.code', '') === 202) {
      response['middleware'] = _.get(res, 'middleware', null);
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }
}
